// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"043ca038","593":"043ca038"}[chunkId] + ".chunk.css";
};